import { COMPANY } from '../../../config/companyConfig.js';
import { SCHEMA_IDS } from './organization.js';

function filterEligibleFaqs(faqs) {
  if (!faqs?.length) return [];
  return faqs.filter((faq) => faq.schemaEligible !== false);
}

function buildFaqMainEntity(faqs) {
  return filterEligibleFaqs(faqs).map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  }));
}

function buildWebPageNode({ pageUrl, pageTitle, description }) {
  return {
    '@type': 'WebPage',
    '@id': `${pageUrl}#webpage`,
    url: pageUrl,
    name: pageTitle,
    description,
    isPartOf: { '@id': SCHEMA_IDS.website },
    about: { '@id': SCHEMA_IDS.organization },
    inLanguage: 'en-IN',
  };
}

/**
 * FAQ route — WebPage + FAQPage @graph.
 */
export function buildFaqPageSchema({ path, pageTitle, description, faqs, faqPageName }) {
  const base = COMPANY.website.replace(/\/+$/, '');
  const pageUrl = `${base}${path}`;
  const mainEntity = buildFaqMainEntity(faqs);

  const graph = [buildWebPageNode({ pageUrl, pageTitle, description })];

  if (mainEntity.length > 0) {
    graph.push({
      '@type': 'FAQPage',
      '@id': `${pageUrl}#faq`,
      name: faqPageName || pageTitle,
      isPartOf: { '@id': `${pageUrl}#webpage` },
      mainEntity,
    });
  }

  return {
    '@context': 'https://schema.org',
    '@graph': graph,
  };
}

/** Standalone FAQPage for homepage (SEO homepage graph excludes FAQ). */
export function buildHomepageFaqSchema({ faqs, pageName }) {
  const mainEntity = buildFaqMainEntity(faqs);
  if (mainEntity.length === 0) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    name: pageName || 'Frequently Asked Questions',
    mainEntity,
  };
}
